import { CaretRight, FilmStrip } from '@/core/ui/icons';
import { formatDuration, lessonCountLabel, type CourseSummary } from '../domain/course';
import { StatusBadge } from './StatusBadge';

interface Props {
  courses: CourseSummary[];
  onOpen: (courseId: string) => void;
}

/**
 * Lista de cursos do backoffice — só o essencial em cada linha: a
 * miniatura do vídeo, o título, quantas aulas e quanto tempo, e o status.
 */
export function CourseTable({ courses, onOpen }: Props) {
  return (
    <ul className="divide-y divide-line overflow-hidden rounded-2xl border border-line bg-surface">
      {courses.map((c) => (
        <li key={c.id}>
          <button
            type="button"
            onClick={() => onOpen(c.id)}
            className="group flex w-full items-center gap-5 px-6 py-4 text-left transition-colors hover:bg-surface-2"
          >
            <Thumb url={c.thumbnail_url} />
            <div className="min-w-0 flex-1">
              <p className="truncate text-base font-medium text-fg">{c.title}</p>
              <p className="mt-1 text-sm text-fg-subtle">
                {lessonCountLabel(c.lesson_count)} · {formatDuration(c.total_duration_s)}
              </p>
            </div>
            <StatusBadge status={c.status} />
            <CaretRight
              aria-hidden
              className="size-4 shrink-0 text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-gray-500"
            />
          </button>
        </li>
      ))}
    </ul>
  );
}

/** O quadro do vídeo; sem vídeo pronto, um espaço neutro do mesmo tamanho. */
function Thumb({ url }: { url: string | null | undefined }) {
  return (
    <div className="flex aspect-video w-32 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-surface-2 ring-1 ring-line">
      {url ? (
        <img src={url} alt="" loading="lazy" className="size-full object-cover" />
      ) : (
        <FilmStrip aria-hidden className="size-6 text-gray-300" />
      )}
    </div>
  );
}
